import { CallEvent } from '@modules/SoftPhoneModule/types';
import TasksModule from '@modules/TasksModule';
import { findStlTaskForCall } from './findStlTaskForCall';

/**
 * Handles phone.call.ended for STL tasks.
 * Sets `hasCallEnded` when the call disconnects, which switches
 * the call button back to "Call" (disabled) with a tooltip.
 */
function handleStlCallEnded(event: CallEvent) {
  if (!event.originating) return;

  const stlTask = findStlTaskForCall(event.remoteIdentity);
  if (!stlTask) return;

  TasksModule.setTaskAttribute(stlTask.id, 'hasCallEnded', true);
}

export default handleStlCallEnded;
